import PropTypes from 'prop-types'
import React from 'react'
import { SelectField } from 'material-ui'

import styles from './styles/bookingDropdown.css'

const BookingDropdown = ({ children, labelText, onChange, value }) => {
  return (
    <SelectField
      floatingLabelFixed
      floatingLabelText={labelText}
      maxHeight={250}
      value={value}
      className={styles.selectField}
      onChange={onChange(labelText)}
    >
      {children}
    </SelectField>
  )
}

BookingDropdown.propTypes = {
  children: PropTypes.arrayOf(PropTypes.object).isRequired,
  labelText: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,
}

export default BookingDropdown



// WEBPACK FOOTER //
// ./src/components/OnlineScheduling/BookingsCalendar/BookingPopover/BookingDropdown.js